export const BASE_VALIDATION_REQUIRED = [
  "START",
  "APPROVE",
  "UNREJECT",
  "SEND_FOR_APPROVAL",
];
export const BASE_COMMENT_REQUIRED = ["REJECT", "REVISION", "ON_HOLD"];
